import steps from './classic.steps'

export default steps
